import * as React from 'react';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import SoundView from '../scenes/partials/modal/scene_command_modals/visualizations/SoundView';

import SoundIcon from './icons/SoundIcon';
import CloseIcon from './icons/CloseIcon';

import Sound from '../../../domain/entities/Sound';

interface Props {
  style?: StyleProp<ViewStyle>;
  sound?: Sound | null;
  addSound: () => void;
  deleteSound: () => void;
}

const AttachmentSoundView: React.FunctionComponent<Props> = props => {
  const {style, sound, addSound, deleteSound} = props;
  return sound ? (
    <View style={[styles.soundPlayOrDelete, style]}>
      <View style={styles.soundPlayButton}>
        <SoundView
          sound={sound}
          iconSize={20}
          labelStyle={styles.soundViewLabel}
        />
      </View>
      <TouchableOpacity style={styles.soundDeleteButton} onPress={deleteSound}>
        <CloseIcon size={11} color={'#383838'} />
      </TouchableOpacity>
    </View>
  ) : (
    <View style={styles.soundAdd}>
      <TouchableOpacity style={styles.soundAddIcon} onPress={addSound}>
        <SoundIcon size={12} />
      </TouchableOpacity>
    </View>
  );
};

export default React.memo(AttachmentSoundView);

const styles = StyleSheet.create({
  soundPlayOrDelete: {
    position: 'absolute',
    left: 8,
    right: 8,
    bottom: 8,
    backgroundColor: '#efefef',
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
  soundPlayButton: {
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
  soundViewLabel: {
    fontSize: 14,
    marginLeft: 5,
  } as ViewStyle,
  soundDeleteButton: {
    position: 'absolute',
    right: 8,
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
  soundAdd: {
    position: 'absolute',
    right: 8,
    bottom: 8,
  } as ViewStyle,
  soundAddIcon: {
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderRadius: 18,
    borderColor: '#383838',
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
});
